export default __webpack_public_path__ + "static/pamela-2a316b60f706b9570b2d70f6230d7e8b.png";